import KksVgbmFormContainer from '@/components/KksVgbmFormContainer/KksVgbmFormContainer.vue';
import AdminPanel from '@/views/AdminPanel/AdminPanel.vue';
import CheckBotConfigurationView from '@/views/CheckBotConfigurationView/CheckBotConfigurationView.vue';
import ContentTypeConfiguration from '@/views/ContentTypeConfiguration/ContentTypeConfiguration.vue';
import CreateDigitalizationProject from '@/views/CreateDigitalizationProject/CreateDigitalizationProject.vue';
import CreateProject from '@/views/CreateProject/CreateProject.vue';
import CreateWorkspace from '@/views/CreateWorkspace/CreateWorkspace.vue';
import DigitalizationProjectDetails from '@/views/DigitalizationProjectDetails/DigitalizationProjectDetails.vue';
import DigitalizationProjectsList from '@/views/DigitalizationProjectsList/DigitalizationProjectsList.vue';
import DocumentDetailView from '@/views/DocumentDetailView/DocumentDetailView.vue';
import DocumentUploadView from '@/views/DocumentUploadView/DocumentUploadView.vue';
import { ErrorType } from '@/views/ErrorView/ErrorView.types';
import ErrorView from '@/views/ErrorView/ErrorView.vue';
import ForbiddenView from '@/views/ForbiddenView/ForbiddenView.vue';
import IframeLoginView from '@/views/IframeLoginView/IframeLoginView.vue';
import MetadataGridEditor from '@/views/MetadataGridEditor/MetadataGridEditor.vue';
import OauthCloseView from '@/views/OauthCloseView/OauthCloseView.vue';
import ProjectDetails from '@/views/ProjectDetails/ProjectDetails.vue';
import ProjectsList from '@/views/ProjectsList/ProjectsList.vue';
import ProjectsSupplierDetails from '@/views/ProjectsSupplierDetailView/ProjectsSupplierDetailView.vue';
import SupplierDetails from '@/views/SupplierDetails/SupplierDetails.vue';
import SuppliersList from '@/views/SuppliersList/SuppliersList.vue';
import UploadUpdateView from '@/views/UploadUpdateView/UploadUpdateView.vue';
import WorkspaceGroupDetailView from '@/views/WorkspaceGroupDetailView/WorkspaceGroupDetailView.vue';
import WorkspaceDetails from '@/views/WorkspaceDetails/WorkspaceDetails.vue';
import WorkspaceDocumentDetailView from '@/views/WorkspaceDocumentDetailView/WorkspaceDocumentDetailView.vue';
import WorkspaceSingleUploadForm from '@/views/WorkspaceSingleUploadForm/WorkspaceSingleUploadForm.vue';
import WorkspacesList from '@/views/WorkspacesList/WorkspacesList.vue';
import { WebTour } from 'types';
import { RouteRecordRaw } from 'vue-router';
import { getWorkspaceDocumentDetailAccessMode } from './helpers';
import { ProjectDataService } from './services';

export const POPUP_LOGIN_REDIRECTION_ROUTE = '/oauth-close';

export enum Route {
  PROJECTS_LIST = 'projectsList',
  CREATE_PROJECT = 'createProject',
  PROJECT_DETAILS = 'projectDetails',
  PROJECT_DETAILS_EXTERNAL = 'projectDetailsExternal',
  PROJECT_SUPPLIER_DETAILS = 'projectsSupplierDetailView',
  CONTENT_TYPE_CONFIGURATION = 'contentTypeConfiguration',
  CHECK_BOT_CONFIGURATOR = 'checkBotConfigurator',
  DOCUMENT_UPLOAD = 'documentUpload',
  UPLOAD_UPDATE = 'uploadUpdate',
  DOCUMENT_DETAIL_VIEW = 'documentDetailView',
  SUPPLIERS_LIST = 'suppliersList',
  SUPPLIER_DETAILS = 'supplierDetails',
  ADMINISTRATION = 'administration',
  DIGITALIZATION_PROJECTS_LIST = 'digitalizationProjectsList',
  CREATE_DIGITALIZATION_PROJECT = 'createDigitalizationProject',
  DIGITALIZATION_PROJECT_DETAILS = 'digitalizationProjectDetails',
  METADATA_GRID_EDITOR = 'metadataGridEditor',
  FORBIDDEN_VIEW = 'forbiddenView',
  KKS_VGBM_FORM = 'kksVgbmForm',
  IFRAME_LOGIN_VIEW = 'iframeLoginView',
  OAUTH_CLOSE_VIEW = 'oauthCloseView',
  ERROR_VIEW = 'errorView',
  WORKSPACES_LIST = 'workspacesList',
  CREATE_WORKSPACE = 'createWorkspace',
  WORKSPACE_DETAILS = 'workspaceDetails',
  WORKSPACE_DOCUMENT_DETAIL_VIEW = 'workspaceDocumentDetailView',
  WORKSPACE_GROUP_DETAILS = 'workspaceGroupDetails',
  WORKSPACE_SINGLE_UPLOAD = 'workspaceSingleUpload',
}

export const PROJECT_ID_PARAM = 'projectId';
export const SUPPLIER_ID_PARAM = 'supplierId';
export const PROJECT_TYPE_PARAM = 'projectType';
export const DOCUMENT_OID_PARAM = 'documentOid';
export const UPLOAD_REFERENCE_NUMBER_PARAM = 'uploadReferenceNumber';
export const TAB_PARAM = 'tab';
export const UPLOAD_ID_PARAM = 'uploadId';
export const WORKSPACE_ID_PARAM = 'workspaceId';
export const WORKSPACE_DOCUMENT_ID_PARAM = 'documentId';
export const WORKSPACE_GROUP_ID_PARAM = 'groupId';
export const CONTENT_TYPE_ID_PARAM = 'contentTypeId';

export const routeParams = {
  [Route.PROJECT_DETAILS]: {
    [PROJECT_ID_PARAM]: 'id',
    [TAB_PARAM]: 'tabNumber',
  },
  [Route.PROJECT_DETAILS_EXTERNAL]: {
    externalProjectId: 'externalId',
    [TAB_PARAM]: 'tabNumber',
  },
  [Route.SUPPLIER_DETAILS]: {
    [SUPPLIER_ID_PARAM]: 'id',
    [TAB_PARAM]: 'tab',
  },
  [Route.DIGITALIZATION_PROJECT_DETAILS]: {
    [PROJECT_ID_PARAM]: 'id',
    [TAB_PARAM]: 'tabNumber',
  },
  [Route.PROJECT_SUPPLIER_DETAILS]: {
    [PROJECT_ID_PARAM]: 'projectId',
    [SUPPLIER_ID_PARAM]: 'supplierId',
    [TAB_PARAM]: 'tabNumber',
  },
  [Route.CONTENT_TYPE_CONFIGURATION]: {
    contentTypeId: 'contentTypeId',
    [PROJECT_ID_PARAM]: 'projectId',
    [PROJECT_TYPE_PARAM]: 'mode',
    [SUPPLIER_ID_PARAM]: 'supplierId',
  },
  [Route.CHECK_BOT_CONFIGURATOR]: {
    [PROJECT_ID_PARAM]: 'projectId',
    query: {
      configId: 'configId',
      [SUPPLIER_ID_PARAM]: 'supplierId',
      templateId: 'templateId',
      [PROJECT_TYPE_PARAM]: 'mode',
    },
  },
  [Route.DOCUMENT_UPLOAD]: {
    query: {
      [PROJECT_TYPE_PARAM]: 'mode',
      checkBotConfigId: 'checkBotConfigId',
      contentTypeId: 'contentTypeId',
      [PROJECT_ID_PARAM]: 'projectId',
      projectName: 'projectName',
      referenceNumber: 'referenceNumber',
      [SUPPLIER_ID_PARAM]: 'supplierId',
      isCheckBotInspectionDisabled: 'isCheckBotInspectionDisabled',
      isNoMetadataUploadMode: 'isNoMetadataUploadMode',
      [TAB_PARAM]: 'tab',
    },
  },
  [Route.UPLOAD_UPDATE]: {
    [UPLOAD_ID_PARAM]: 'uploadId',
    [PROJECT_ID_PARAM]: 'projectId',
  },
  [Route.DOCUMENT_DETAIL_VIEW]: {
    [PROJECT_TYPE_PARAM]: 'mode',
    [DOCUMENT_OID_PARAM]: 'documentOid',
    [TAB_PARAM]: 'tab',
    query: {
      [PROJECT_ID_PARAM]: 'projectId',
      [UPLOAD_REFERENCE_NUMBER_PARAM]: 'uploadReferenceNumber',
    },
  },
  [Route.METADATA_GRID_EDITOR]: {
    digitalizationProjectId: 'digitalizationProjectId',
    mode: 'mode',
    query: {
      [PROJECT_ID_PARAM]: 'projectId',
    },
  },
  [Route.KKS_VGBM_FORM]: {
    kksCodeWithLocation: 'kksCodeWithLocation',
  },
  [Route.ERROR_VIEW]: {
    errorType: 'errorType',
    query: {
      externalProjectId: 'externalProjectId',
    },
  },
  [Route.WORKSPACE_DETAILS]: {
    [WORKSPACE_ID_PARAM]: 'workspaceId',
    [TAB_PARAM]: 'tab',
    query: {
      documentsTab: 'documentsTab',
    },
  },
  [Route.WORKSPACE_DOCUMENT_DETAIL_VIEW]: {
    [WORKSPACE_ID_PARAM]: 'workspaceId',
    [WORKSPACE_DOCUMENT_ID_PARAM]: 'documentId',
    query: {
      documentsTab: 'documentsTab',
    },
  },
  [Route.WORKSPACE_GROUP_DETAILS]: {
    [WORKSPACE_ID_PARAM]: 'workspaceId',
    [WORKSPACE_GROUP_ID_PARAM]: 'groupId',
    [TAB_PARAM]: 'tab',
  },
  [Route.WORKSPACE_SINGLE_UPLOAD]: {
    [WORKSPACE_ID_PARAM]: 'workspaceId',
    [CONTENT_TYPE_ID_PARAM]: 'contentTypeId',
  },
};

const routes: RouteRecordRaw[] = [
  {
    name: Route.PROJECTS_LIST,
    path: '/projects',
    component: ProjectsList,
    meta: { tourKey: WebTour.START_PAGE },
  },
  {
    name: Route.CREATE_PROJECT,
    path: '/projects/create-project',
    component: CreateProject,
  },
  {
    name: Route.PROJECT_DETAILS,
    path: `/project-details/:${routeParams[Route.PROJECT_DETAILS].projectId}/:${
      routeParams[Route.PROJECT_DETAILS][TAB_PARAM]
    }?`,
    component: ProjectDetails,
    props: true,
  },
  {
    name: Route.PROJECT_DETAILS_EXTERNAL,
    path: `/project-details/external/:${
      routeParams[Route.PROJECT_DETAILS_EXTERNAL].externalProjectId
    }/:${routeParams[Route.PROJECT_DETAILS_EXTERNAL][TAB_PARAM]}?`,
    component: ProjectDetails,
    props: true,
    beforeEnter: async (to) => {
      const externalId =
        to.params[
          routeParams[Route.PROJECT_DETAILS_EXTERNAL].externalProjectId
        ];
      if (typeof externalId !== 'string') {
        throw new Error('External ID is missing in route params');
      }
      try {
        const projectId =
          await ProjectDataService.getProjectIdByExternalId(externalId);
        return {
          name: Route.PROJECT_DETAILS,
          params: {
            [routeParams[Route.PROJECT_DETAILS].projectId]: projectId,
            [routeParams[Route.PROJECT_DETAILS][TAB_PARAM]]:
              to.params[routeParams[Route.PROJECT_DETAILS_EXTERNAL][TAB_PARAM]],
          },
        };
      } catch {
        return {
          name: Route.ERROR_VIEW,
          params: {
            [routeParams[Route.ERROR_VIEW].errorType]:
              ErrorType.PROJECT_WITH_EXTERNAL_ID_NOT_FOUND,
          },
          query: {
            [routeParams[Route.ERROR_VIEW].query.externalProjectId]: externalId,
          },
        };
      }
    },
  },
  {
    name: Route.PROJECT_SUPPLIER_DETAILS,
    path:
      '/project-suppliers/' +
      `:${routeParams[Route.PROJECT_SUPPLIER_DETAILS].projectId}/` +
      `:${routeParams[Route.PROJECT_SUPPLIER_DETAILS].supplierId}/` +
      `:${routeParams[Route.PROJECT_SUPPLIER_DETAILS][TAB_PARAM]}?`,
    component: ProjectsSupplierDetails,
    props: true,
  },
  {
    name: Route.CONTENT_TYPE_CONFIGURATION,
    path:
      '/content-type-configuration/' +
      `:${routeParams[Route.CONTENT_TYPE_CONFIGURATION].contentTypeId}/` +
      `:${routeParams[Route.CONTENT_TYPE_CONFIGURATION].projectId}/` +
      `:${routeParams[Route.CONTENT_TYPE_CONFIGURATION][PROJECT_TYPE_PARAM]}/` +
      `:${routeParams[Route.CONTENT_TYPE_CONFIGURATION].supplierId}?`,
    component: ContentTypeConfiguration,
    props: true,
  },
  {
    name: Route.CHECK_BOT_CONFIGURATOR,
    path:
      '/check-bot-configurator/' +
      `:${routeParams[Route.CHECK_BOT_CONFIGURATOR].projectId}`,
    component: CheckBotConfigurationView,
    props: (route) => ({
      configId:
        route.query[routeParams[Route.CHECK_BOT_CONFIGURATOR].query.configId],
      projectId:
        route.params[
          routeParams[Route.CHECK_BOT_CONFIGURATOR][PROJECT_ID_PARAM]
        ],
      supplierId:
        route.query[routeParams[Route.CHECK_BOT_CONFIGURATOR].query.supplierId],
      templateId:
        route.query[routeParams[Route.CHECK_BOT_CONFIGURATOR].query.templateId],
    }),
  },
  {
    name: Route.DOCUMENT_UPLOAD,
    path: '/document-upload',
    component: DocumentUploadView,
    props: (route) => ({
      mode: route.query[
        routeParams[Route.DOCUMENT_UPLOAD].query[PROJECT_TYPE_PARAM]
      ],
      referenceNumber:
        route.query[routeParams[Route.DOCUMENT_UPLOAD].query.referenceNumber],
      contentTypeId:
        route.query[routeParams[Route.DOCUMENT_UPLOAD].query.contentTypeId],
      projectId:
        route.query[routeParams[Route.DOCUMENT_UPLOAD].query.projectId],
      projectName:
        route.query[routeParams[Route.DOCUMENT_UPLOAD].query.projectName],
      supplierId:
        route.query[routeParams[Route.DOCUMENT_UPLOAD].query.supplierId],
      checkBotConfigId:
        route.query[routeParams[Route.DOCUMENT_UPLOAD].query.checkBotConfigId],
      isCheckBotInspectionDisabled:
        route.query[
          routeParams[Route.DOCUMENT_UPLOAD].query.isCheckBotInspectionDisabled
        ],
      isNoMetadataUploadMode:
        route.query[
          routeParams[Route.DOCUMENT_UPLOAD].query.isNoMetadataUploadMode
        ],
      tab: route.query[routeParams[Route.DOCUMENT_UPLOAD].query[TAB_PARAM]],
    }),
  },
  {
    name: Route.UPLOAD_UPDATE,
    path:
      '/upload-update' +
      `/:${routeParams[Route.UPLOAD_UPDATE][UPLOAD_ID_PARAM]}` +
      `/:${routeParams[Route.UPLOAD_UPDATE][PROJECT_ID_PARAM]}`,
    component: UploadUpdateView,
    props: true,
  },
  {
    name: Route.DOCUMENT_DETAIL_VIEW,
    path:
      '/document-detail-view/' +
      `:${routeParams[Route.DOCUMENT_DETAIL_VIEW][PROJECT_TYPE_PARAM]}/` +
      `:${routeParams[Route.DOCUMENT_DETAIL_VIEW].documentOid}/` +
      `:${routeParams[Route.DOCUMENT_DETAIL_VIEW][TAB_PARAM]}?`,
    component: DocumentDetailView,
    props: true,
  },
  {
    name: Route.SUPPLIERS_LIST,
    path: '/suppliers',
    component: SuppliersList,
  },
  {
    name: Route.SUPPLIER_DETAILS,
    path: `/supplier-details/:${
      routeParams[Route.SUPPLIER_DETAILS].supplierId
    }/:${routeParams[Route.SUPPLIER_DETAILS][TAB_PARAM]}?`,
    component: SupplierDetails,
    props: true,
  },
  {
    name: Route.ADMINISTRATION,
    path: '/administration',
    component: AdminPanel,
  },
  {
    name: Route.DIGITALIZATION_PROJECTS_LIST,
    path: '/digitalization-projects',
    component: DigitalizationProjectsList,
  },
  {
    name: Route.CREATE_DIGITALIZATION_PROJECT,
    path: '/digitalization-projects/create-project',
    component: CreateDigitalizationProject,
  },
  {
    name: Route.DIGITALIZATION_PROJECT_DETAILS,
    path:
      '/digitalization-projects/digitalization-project-details/' +
      `:${routeParams[Route.DIGITALIZATION_PROJECT_DETAILS].projectId}/` +
      `:${routeParams[Route.DIGITALIZATION_PROJECT_DETAILS][TAB_PARAM]}?`,
    component: DigitalizationProjectDetails,
    props: true,
  },
  {
    name: Route.METADATA_GRID_EDITOR,
    path:
      '/metadata-grid-editor/' +
      `:${routeParams[Route.METADATA_GRID_EDITOR].digitalizationProjectId}` +
      `/:${routeParams[Route.METADATA_GRID_EDITOR].mode}`,
    component: MetadataGridEditor,
    props: true,
  },
  {
    name: Route.WORKSPACES_LIST,
    path: '/workspaces',
    component: WorkspacesList,
  },
  {
    name: Route.CREATE_WORKSPACE,
    path: '/workspaces/create-workspace',
    component: CreateWorkspace,
  },
  {
    name: Route.WORKSPACE_DETAILS,
    path: `/workspaces/:${
      routeParams[Route.WORKSPACE_DETAILS].workspaceId
    }/:${routeParams[Route.WORKSPACE_DETAILS][TAB_PARAM]}?`,
    component: WorkspaceDetails,
    props: true,
  },
  {
    name: Route.WORKSPACE_DOCUMENT_DETAIL_VIEW,
    path: `/workspaces/:${
      routeParams[Route.WORKSPACE_DOCUMENT_DETAIL_VIEW].workspaceId
    }/documents/:${
      routeParams[Route.WORKSPACE_DOCUMENT_DETAIL_VIEW].documentId
    }`,
    component: WorkspaceDocumentDetailView,
    props: (route) => ({
      workspaceId:
        route.params[
          routeParams[Route.WORKSPACE_DOCUMENT_DETAIL_VIEW].workspaceId
        ],
      documentId:
        route.params[
          routeParams[Route.WORKSPACE_DOCUMENT_DETAIL_VIEW].documentId
        ],
      accessMode: getWorkspaceDocumentDetailAccessMode(
        typeof route.query.documentsTab === 'string'
          ? route.query.documentsTab
          : undefined,
      ),
    }),
  },
  {
    name: Route.WORKSPACE_SINGLE_UPLOAD,
    path: `/workspaces/:${
      routeParams[Route.WORKSPACE_SINGLE_UPLOAD].workspaceId
    }/documents/upload/:${
      routeParams[Route.WORKSPACE_SINGLE_UPLOAD].contentTypeId
    }`,
    component: WorkspaceSingleUploadForm,
    props: true,
  },
  {
    name: Route.WORKSPACE_GROUP_DETAILS,
    path: `/workspaces/:${
      routeParams[Route.WORKSPACE_GROUP_DETAILS].workspaceId
    }/groups/:${routeParams[Route.WORKSPACE_GROUP_DETAILS].groupId}/:${
      routeParams[Route.WORKSPACE_GROUP_DETAILS][TAB_PARAM]
    }?`,
    component: WorkspaceGroupDetailView,
    props: true,
  },
  {
    name: Route.KKS_VGBM_FORM,
    path: `/kks-vgbm-form/:${
      routeParams[Route.KKS_VGBM_FORM].kksCodeWithLocation
    }`,
    component: KksVgbmFormContainer,
    props: true,
  },
  {
    name: Route.IFRAME_LOGIN_VIEW,
    path: '/iframe-login',
    component: IframeLoginView,
  },
  {
    name: Route.OAUTH_CLOSE_VIEW,
    path: '/oauth-close',
    component: OauthCloseView,
  },
  {
    name: Route.FORBIDDEN_VIEW,
    path: '/forbidden',
    component: ForbiddenView,
  },
  {
    name: Route.ERROR_VIEW,
    path: `/error/:${routeParams[Route.ERROR_VIEW].errorType}`,
    component: ErrorView,
    props: (route) => ({
      errorType: route.params[routeParams[Route.ERROR_VIEW].errorType],
      externalProjectId:
        route.query[routeParams[Route.ERROR_VIEW].query.externalProjectId],
    }),
  },
  {
    path: '/:pathMatch(.*)*',
    name: Route.PROJECTS_LIST,
    component: ProjectsList,
    meta: { tourKey: WebTour.START_PAGE },
  },
];

export default routes;
